import React, { useState } from 'react';
import HeadersAuth from '../../components/base/HeadersAuth';
import { INTRO_VIDEO_URL, RISK_VIDEO_URL } from '../../config/videos';

const LearnPage = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [showVideoModal, setShowVideoModal] = useState(false);

  const trainingVideos = [
    {
      id: 1,
      title: "Quantum Flo Auto Algo(QFAA) for ETFs Set Up and Usage",
      description: "Learn how to set up and use Quantum Flo Auto Algo for ETF trading",
      duration: "6:55",
      thumbnail: "/photo/graph-thumbnail.jpg",
      videoUrl: "https://firebasestorage.googleapis.com/v0/b/quantum-flo-auto-algo-d3c2b.firebasestorage.app/o/vdo1.mp4?alt=media&token=09181fb0-d246-4107-82b5-33333524ef45" // ใส่ URL จาก Firebase Storage ที่นี่
    },
    {
      id: 2,
      title: "QFAA Broker Connection Guide",
      description: "Step-by-step guide to connecting your broker account to QFAA",
      duration: "8:32",
      thumbnail: "/photo/graph-thumbnail.jpg",
      videoUrl: RISK_VIDEO_URL
    },
    {
      id: 3,
      title: "QFAA Trading Rules & Trade Frequency",
      description: "Understanding QFAA trading rules and frequency of trades",
      duration: "10:18",
      thumbnail: "/photo/graph-thumbnail.jpg",
      videoUrl: INTRO_VIDEO_URL
    },
    {
      id: 4,
      title: "QFAA Trade Management Features",
      description: "Explore the advanced trade management features in QFAA",
      duration: "9:45",
      thumbnail: "/photo/graph-thumbnail.jpg",
      videoUrl: RISK_VIDEO_URL
    },
    {
      id: 5,
      title: "QFAA Monitoring Performance",
      description: "How to monitor and track your QFAA trading performance",
      duration: "7:23",
      thumbnail: "/photo/graph-thumbnail.jpg",
      videoUrl: INTRO_VIDEO_URL
    },
    {
      id: 6,
      title: "QFAA Schwab Brokerage Account Check",
      description: "How to verify and check your Schwab brokerage account connection",
      duration: "5:56",
      thumbnail: "/photo/graph-thumbnail.jpg",
      videoUrl: RISK_VIDEO_URL
    },
    {
      id: 7,
      title: "QFAA Refresh Schwab Token",
      description: "Step-by-step guide to refreshing your Schwab access token",
      duration: "6:12",
      thumbnail: "/photo/graph-thumbnail.jpg",
      videoUrl: INTRO_VIDEO_URL
    },
    {
      id: 8,
      title: "QFAA Tastytrade Brokerage Check",
      description: "How to verify and check your Tastytrade account connection",
      duration: "4:38",
      thumbnail: "/photo/graph-thumbnail.jpg",
      videoUrl: RISK_VIDEO_URL
    },
    {
      id: 9,
      title: "QFAA Tradier Brokerage Check",
      description: "How to verify and check your Tradier account connection",
      duration: "5:15",
      thumbnail: "/photo/graph-thumbnail.jpg",
      videoUrl: INTRO_VIDEO_URL
    }
  ];

  const openVideo = (video) => {
    setSelectedVideo(video);
    setShowVideoModal(true);
  };

  const closeVideo = () => {
    setShowVideoModal(false);
    setSelectedVideo(null);
  };


  return (
    <div className="bg-[#0b0d2a] text-white font-sans min-h-screen">
      <HeadersAuth />
      <div className="pt-32 pb-12">
        <div className="max-w-6xl mx-auto py-8 px-4">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-white mb-4">Training Videos</h1>
            <p className="text-xl text-gray-300">
              Master Quantum Flo with our comprehensive video tutorials
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {trainingVideos.map((video) => (
              <div key={video.id} className="bg-gray-800 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="relative cursor-pointer" onClick={() => openVideo(video)}>
                  <img 
                    src={video.thumbnail} 
                    alt={video.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="absolute top-2 right-2 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-sm">
                    {video.duration}
                  </div>
                  <div className="absolute inset-0 bg-black bg-opacity-20 hover:bg-opacity-40 transition-all duration-300 flex items-center justify-center">
                    <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center backdrop-blur-sm">
                      <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z"/>
                      </svg>
                    </div>
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-white mb-2">{video.title}</h3>
                  <p className="text-gray-300 text-sm">{video.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center">
            <div className="bg-gradient-to-r from-purple-600 to-blue-600 p-8 rounded-xl">
              <h2 className="text-2xl font-bold text-white mb-4">Ready to Start Learning?</h2>
              <p className="text-purple-100 mb-6">
                Begin with our introduction video and work your way through the training series
              </p>
              <button 
                className="bg-white text-purple-600 font-bold py-3 px-8 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                onClick={() => openVideo(trainingVideos[0])}
              >
                Start with QFAA Setup
              </button>
            </div>
          </div>

          {/* Video Modal */}
          {showVideoModal && selectedVideo && (
            <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4">
              <div className="relative w-full max-w-4xl">
                <button
                  onClick={closeVideo}
                  className="absolute top-4 right-4 text-white bg-black bg-opacity-60 p-2 rounded-full z-50 hover:bg-opacity-80 transition-all"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
                
                <div className="bg-gray-900 rounded-lg overflow-hidden">
                  <div className="p-6 border-b border-gray-700">
                    <h2 className="text-2xl font-bold text-white mb-2">{selectedVideo.title}</h2>
                    <p className="text-gray-300">{selectedVideo.description}</p>
                  </div>
                  
                  <div className="relative">
                    {(() => {
                      const url = selectedVideo.videoUrl || '';
                      const isYouTube = /youtube\.com|youtu\.be/.test(url);
                      const isDrive = /drive\.google\.com/.test(url);
                      const isVimeo = /vimeo\.com/.test(url);
                      if (isVimeo) {
                        // Accept links like https://vimeo.com/123456789 or player URLs
                        let idMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
                        const embedUrl = idMatch && idMatch[1]
                          ? `https://player.vimeo.com/video/${idMatch[1]}`
                          : url; // fallback if already player URL
                        return (
                          <iframe
                            className="w-full aspect-video"
                            src={selectedVideo.videoUrl}
                            title={selectedVideo.title}
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                            style={{
                              border: 'none',
                              borderRadius: '8px'
                            }}
                          />
                        );
                      }
                      if (isYouTube) {
                        // Expect url like https://www.youtube.com/embed/VIDEO_ID or watch?v=VIDEO_ID
                        let embedUrl = url;
                        const match = url.match(/[?&]v=([^&]+)/);
                        if (match && match[1]) {
                          embedUrl = `https://www.youtube.com/embed/${match[1]}`;
                        }
                        return (
                          <iframe
                            className="w-full aspect-video"
                            src={embedUrl}
                            title={selectedVideo.title}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                          />
                        );
                      }
                      if (isDrive) {
                        // Google Drive blocks embedding on external sites (CSP frame-ancestors)
                        // Fallback: show an open-in-new-tab button
                        const open = () => window.open(url, '_blank', 'noopener,noreferrer');
                        return (
                          <div className="flex flex-col items-center justify-center aspect-video bg-black/60">
                            <p className="text-gray-300 mb-4 px-4 text-center">
                              This Google Drive video cannot be embedded due to site restrictions. Open it in a new tab.
                            </p>
                            <button onClick={open} className="bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded">
                              Open in Google Drive
                            </button>
                          </div>
                        );
                      }
                      return (
                        <video 
                          controls 
                          autoPlay 
                          className="w-full h-auto"
                          controlsList="nodownload"
                        >
                          <source src={url} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LearnPage;